import loadLocale3 from "./loadLocale3";

const locale3 = {
  loadLocale3,
};

export default locale3;
